// export const BASE_URL = process.env.NODE_ENV === 'development' ?  'http://localhost:5000'  :  '';
export const BASE_URL = process.env.REACT_APP_API_URL;
export const LOAN_APPLICATIONS_URL = `${BASE_URL}/api/google-sheets`;
export const CONTACT_URL = `${BASE_URL}/api/google-sheets`;

console.log("BASE_URL:", process.env.REACT_APP_API_URL);